import React, { Component } from "react";
import { FaExternalLinkAlt } from "react-icons/fa";

class TermsOfUse extends Component {
  render() {
    return (
      <div className="TermsOfUseModal">
        <p>
          Coletamos seu nome completo e e-mail para que seja usado em seu login
          e exibição na plataforma do hotsite prêmio do{" "}
          <b>Jovem do Ano DRAFT5</b>. Não repassaremos para nenhum parceiro. Ao
          se inscrever no hotsite da votação{" "}
          <b>você concorda integralmente com isso</b>.
          <br />
          <br />
          <a href="https://privacy.gamersclub.gg/privacy/" target=" _blank">
            Para ler o nossos termos e políticas de forma completa, clique aqui{" "}
            <FaExternalLinkAlt size={10} />
          </a>
        </p>
      </div>
    );
  }
}

export default TermsOfUse;
